import React from 'react';
import PropTypes from 'prop-types';
import { labelAndIcon } from 'helper/saved-poi-helper';
import _get from 'lodash/get';
import styles from './saved-poi-unit-card.less';

const SavedPoiUnitCard = ({ savedPoi, onClickSavedPOIsUnitCard, index }) => {
  const { label, icon } = labelAndIcon(savedPoi);
  return (
    <div
      onClick={onClickSavedPOIsUnitCard(savedPoi, index)}
      className={styles.addressCardWrapper}
    >
      <img alt="" src={icon} className={styles.icon} />
      <div className={styles.addressInfo}>
        <div className={styles.firstLine}>{label}</div>
        <div className={styles.secondLine}>
          {_get(savedPoi, ['address', 'combined_address'])}
        </div>
      </div>
    </div>
  );
};

SavedPoiUnitCard.propTypes = {
  savedPoi: PropTypes.shape({}).isRequired,
  onClickSavedPOIsUnitCard: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};

export default SavedPoiUnitCard;
